import { Select, Tag } from "antd";

const tagRender = (props) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      // onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {label}
    </Tag>
  );
};

const ColVisibilityDropdown = ({ options, columns, columnsToShowHandler }) => {
  const localOptions = options.filter((option) => option.title?.length >= 2);

  // Antd expects {label, value}
  const modOptions = localOptions.map((option) => ({
    value: option.title,
    label: option.title,
    id: option.id,
  }));

  const defaultValue = modOptions.map((o) => o.value);

  const handleChange = (selectedCols) => {
    const columnsToShow = columns.filter((col) =>
      selectedCols.includes(col.title)
    );

    // keep the empty-title column if present
    const emptyCol = columns.find((item) => item?.title === "");
    if (emptyCol) columnsToShow.push(emptyCol);

    columnsToShowHandler(columnsToShow);
  };

  return (
    <div className="min-w-[110px] md:max-w-[165px] w-1/2 md:w-auto">
      <Select
        mode="multiple"
        tagRender={tagRender}
        defaultValue={defaultValue}
        maxTagCount={0}
        options={modOptions}
        maxTagPlaceholder="Columns"
        placeholder="Column Visibility"
        onChange={handleChange}
        popupClassName="w-[200px]"
        showSearch={false}     // 👈 hides the type-to-search input
        filterOption={false}    // 👈 ensures no client-side filtering UI
      />
    </div>
  );
};

export default ColVisibilityDropdown;
